import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "@shared/shared.module";
import { ToolkitGestioneAnagraficaTabAnagraficaLeggeComponent } from "./tab-anagrafica-legge/tab-anagrafica-legge.component";
import { NgModule } from "@angular/core";

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, SharedModule, NgbModule],
  declarations: [ToolkitGestioneAnagraficaTabAnagraficaLeggeComponent],
  exports: [ToolkitGestioneAnagraficaTabAnagraficaLeggeComponent],
})
export class PagesGestioneAnagraficaToolkitModule {}
